import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SicotService } from '../sicot.service';

@Component({
  selector: 'app-admin-esito-uvm-pai',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    FormsModule,
    HeaderComponent,
    FooterComponent,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './admin-esito-uvm-pai.component.html',
  styleUrl: './admin-esito-uvm-pai.component.css',
})
export class AdminEsitoUvmPaiComponent implements OnInit {
  private readonly sicot = inject(SicotService);

  settings: { codice: string; descrizione?: string }[] = [];
  loadingSettings = true;
  sending = false;
  message: string | null = null;
  isError = false;

  richiestaId: number | null = null;
  sistemaRichiedente = 'Admin SI-COT';
  operatoreCodice = '';
  dataInizio = '';
  dataFine = '';
  codProfiloCura = '';
  descProfiloCura = '';
  identificativoPianoAssistenziale = '';
  identificativoSchedaValutazione = '';
  cambioSetting = '';
  codTipoErogatore = '';
  tipoFrequenza = '';
  numeroAccessiPrevisti = '1';
  codAttivita = '';

  ngOnInit(): void {
    this.sicot.getSetting().subscribe({
      next: (list) => {
        this.settings = list ?? [];
        if (this.settings.length > 0 && !this.cambioSetting) {
          this.cambioSetting = (this.settings[0] as { codice?: string }).codice ?? '';
        }
        this.loadingSettings = false;
      },
      error: () => {
        this.loadingSettings = false;
      },
    });
  }

  invia(): void {
    if (this.richiestaId == null || this.richiestaId <= 0) {
      this.message = 'Inserire ID richiesta valido';
      this.isError = true;
      return;
    }
    if (!this.operatoreCodice?.trim()) {
      this.message = 'Codice operatore obbligatorio';
      this.isError = true;
      return;
    }
    if (!this.cambioSetting?.trim()) {
      this.message = 'Setting obbligatorio';
      this.isError = true;
      return;
    }
    if (!this.dataInizio?.trim() || !this.dataFine?.trim()) {
      this.message = 'Data inizio e data fine obbligatorie';
      this.isError = true;
      return;
    }
    if (!this.codProfiloCura?.trim() || !this.descProfiloCura?.trim()) {
      this.message = 'Profilo cura (codice e descrizione) obbligatorio';
      this.isError = true;
      return;
    }

    this.message = null;
    this.isError = false;
    this.sending = true;

    const body = {
      richiestaId: this.richiestaId,
      sistemaRichiedente: this.sistemaRichiedente || 'Admin SI-COT',
      operatore: { idOperatore: this.operatoreCodice.trim() },
      dataInizio: this.dataInizio.trim(),
      dataFine: this.dataFine.trim(),
      profiloCura: { codProfiloCura: this.codProfiloCura.trim(), descProfiloCura: this.descProfiloCura.trim() },
      identificativoPianoAssistenziale: this.identificativoPianoAssistenziale?.trim() || '',
      identificativoSchedaValutazione: this.identificativoSchedaValutazione?.trim() || '',
      allegati: [],
      cambioSetting: this.cambioSetting.trim(),
      interventi: [
        {
          codTipoErogatore: this.codTipoErogatore?.trim() || '',
          tipoFrequenza: this.tipoFrequenza?.trim() || '',
          numeroAccessiPrevisti: this.numeroAccessiPrevisti?.trim() || '1',
          attivitaPreviste: this.codAttivita?.trim() ? [{ codAttivita: this.codAttivita.trim() }] : [],
        },
      ],
    };

    this.sicot.postAdminEsitoUvmPai(body).subscribe({
      next: (res: unknown) => {
        this.sending = false;
        const r = res as { success?: boolean; message?: string };
        if (r?.success === false && r?.message) {
          this.message = r.message;
          this.isError = true;
        } else {
          this.message = 'Esito UVM con PAI inviato. Il workflow può proseguire.';
          this.isError = false;
        }
      },
      error: (err) => {
        this.sending = false;
        this.message = err?.error?.message || err?.message || 'Errore durante l\'invio';
        this.isError = true;
      },
    });
  }
}
